import script from "./PUTT.vue?vue&type=script&setup=true&lang=ts"
export * from "./PUTT.vue?vue&type=script&setup=true&lang=ts"

import "./PUTT.vue?vue&type=style&index=0&id=5938694f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5938694f"]])

export default __exports__